export const convertCurrency = (price) => {
    return `${parseFloat(price).toFixed(3)} MAD`
}
export const formatNumberWithSpaces = (num) => {
    if (typeof num !== "number") return num; 
    return num.toLocaleString("en").replace(/,/g, " "); 
  };